module.exports = {
  entry: './src/apps/world-map-leadspace/index.tsx',
  shortcode: 'world-map-leadspace',
  title: 'World Map Leadspace',
  status: 'stable',
  description:
    'A Leadspace featuring an interactive Map that displays Data-centers info globally',
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    availableTranslations: [
      'de',
      'en',
      'es',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
